import SearchContactInput from './SearchContactInput';

export default SearchContactInput;
